module.exports = __webpack_public_path__ + "static/media/sayabout-user2.c18724dd.jpg";